
import store from '@/store';
import {
  computed, defineComponent, Ref, ref, watchEffect,
} from '@vue/composition-api';
import api from '@/api';

export default defineComponent({
  name: 'Alert',

  setup() {
    const loadError = computed(() => store.state.loadError);

    // Vars to store the selected choices in
    const workspace: Ref<string | null> = ref(null);
    const network: Ref<string | null> = ref(null);

    // Compute the workspace/network options
    const workspaceOptions: Ref<string[]> = ref([]);
    watchEffect(async () => {
      workspaceOptions.value = (await api.workspaces()).results.map((workspaceObj) => workspaceObj.name);
    });

    const networkOptions: Ref<string[]> = ref([]);
    watchEffect(async () => {
      if (workspace.value !== null) {
        networkOptions.value = (await api.networks(workspace.value)).results.map((networkObj) => networkObj.name);
      }
    });

    const buttonHref: Ref<string> = ref(loadError.value.href);
    const buttonText: Ref<string> = ref('');
    watchEffect(async () => {
      if (workspace.value !== null && network.value !== null) {
        buttonHref.value = `./?workspace=${workspace.value}&network=${network.value}`;
        buttonText.value = 'Go To Network';
      } else if (loadError.value.message === 'There was a network issue when getting data') {
        buttonHref.value = loadError.value.href;
        buttonText.value = 'Refresh the page';
      } else {
        buttonHref.value = loadError.value.href;
        buttonText.value = 'Back to MultiNet';
      }
    });

    return {
      buttonHref,
      buttonText,
      loadError,
      network,
      networkOptions,
      workspace,
      workspaceOptions,
    };
  },
});
